module.exports = __webpack_public_path__ + "img/audit_success.5f9d5a99.png";